import { render, staticRenderFns } from "./HistoricRevisions.vue?vue&type=template&id=b1a6f742&"
import script from "./HistoricRevisions.vue?vue&type=script&lang=js&"
export * from "./HistoricRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports